// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 982 ? "product-detail" : chunkId) + "." + {"22":"09abc193","809":"b7c1c9a6","982":"6e4e970e"}[chunkId] + ".js";
};